import React from 'react';
import { Modal } from 'mui';
import { useAppSelector } from 'app/helpers/hooks';
import { selectCustomer } from 'app/selectors/customer';
import ReferralLink from 'app/components/common/ReferralLink';

interface ReferralModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ReferralModal: React.FC<ReferralModalProps> = ({ isOpen, onClose }) => {
  const customer = useAppSelector(selectCustomer);
  const referralCode = customer.get('referral_code');

  return (
    <Modal isOpen={isOpen} onClose={onClose} showCloseIcon={true}>
      <Modal.Header>
        <h4>Give $50, get $50</h4>
      </Modal.Header>
      <Modal.Body>
        <p>
          When you refer a friend, they'll receive $50 off their first new plan, and you'll receive a $50 credit applied
          to your next bill.
        </p>

        <p className="heading-label text-[#798DFF]">HOW IT WORKS</p>
        <ol className="list-decimal pl-5">
          <li className="mb-3">Share your unique referral link – invite those who would benefit from Maximus Tribe.</li>
          <li className="mb-3">They subscribe & save – your friend gets $50 off their first prescription purchase.</li>
          <li>You earn $50 – for every successful referral, you receive a $50 credit, applied to your next bill.</li>
        </ol>

        <a href="https://app.maximustribe.com/terms-of-use" target="_blank" rel="noopener noreferrer">
          Terms & Conditions
        </a>

        <ReferralLink referralCode={referralCode} />
      </Modal.Body>
    </Modal>
  );
};

export default ReferralModal;
